import { mapGetters } from 'vuex';

const Overlay = {
	name: 'Overlay',
	template: `
		<div class="wrapper-overlay" :class="{
		'wrapper-overlay--visible': showOverlay,
		'wrapper-overlay--hidden': !showOverlay,
		'wrapper-overlay--full': showFull
		}" @click="closeOverlay">
		</div>
	`,
	methods: {
		closeOverlay: function() {
			this.$store.dispatch('overlay/hide');
		}
	},
	watch: {
		showOverlay: function(show) {
			if(!show && typeof(this.overlayCallback) === 'function') {
				this.overlayCallback();
			}
		},
	},
	computed: {
		...mapGetters({
			showOverlay: 'overlay/show',
			showFull: 'overlay/full',
			overlayCallback: 'overlay/callback',
		}),
	}
};

export default Overlay;



// WEBPACK FOOTER //
// ../shared/components/overlay/index.js